import React, {Component}               from "react";
import {ImageBackground, Text, View}    from "react-native";
import {connect}                        from "react-redux";
import Modal                            from "./Modal";
import NBButton                         from "../NBButton";
import * as Actions                     from "../../constants/Actions";
import styles                           from "../../styles/Styles";

class ModalClues extends Component {
    render() {
        if (this.props.info == null)
            return null;

        var country = null;
        var isUS = false;
        if (this.props.info.country != null) {
            if (this.props.info.country == "USA")
                isUS = true;

            country = 
                <View style={styles.modalDetailRow}>
                    <Text style={styles.modalDetailText}>First Released in</Text>
                    <Text style={styles.modalDetailText}>{this.props.info.country}</Text>
                </View>;
        }

        var genre = null;
        if (this.props.info.genre != null) {
            genre = 
                <View style={styles.modalDetailRow}>
                    <Text style={styles.modalDetailText}>Genre</Text>
                    <Text style={styles.modalDetailText}>{this.props.info.genre}</Text>
                </View>;
        }

        var rating = null;
        if (this.props.info.rating != null) {
            rating = 
                <View style={styles.modalDetailRow}>
                    <Text style={styles.modalDetailText}>Rating</Text>
                    <Text style={styles.modalDetailText}>{this.props.info.rating}</Text>
                </View>;
        }

        var releaseOriginal = null;
        if (this.props.info.releaseOriginal != null) {
            releaseOriginal = 
                <View style={styles.modalDetailRow}>
                    <Text style={styles.modalDetailText}>First Released on</Text>
                    <Text style={styles.modalDetailText}>{this.props.info.releaseOriginal}</Text>
                </View>;
        }

        var releaseUS = null;
        if (this.props.info.releaseUS != null && !isUS) {
            releaseUS = 
                <View style={styles.modalDetailRow}>
                    <Text style={styles.modalDetailText}>US Release</Text>
                    <Text style={styles.modalDetailText}>{this.props.info.releaseUS}</Text>
                </View>;
        }

        return (
            <View>
                <Modal animationType={"fade"} onRequestClose={null} supportedOrientations={["landscape"]} transparent={true}
                    visible={this.props.showCluesExtra}>
                    {/* Modal Background is a hack to dim the screen behind the modal */}
                    <View style={styles.modalBackground}>
                        <View style={styles.modalDialog}>
                            <ImageBackground source={require("../../../assets/clapboard_temp.png")} style={styles.backgroundModal} imageStyle={styles.backgroundImageStretch}>
                                <View style={styles.modalDialogInner}>
                                    {/* Header Row */}
                                    <View style={styles.modalDetailRow}>
                                        <Text style={styles.modalDetailText}>Additional Clues</Text>
                                    </View>
                                    <View style={styles.lineHorizontalModal} />

                                    {country}
                                    {releaseOriginal}
                                    {releaseUS}
                                    {genre}
                                    {rating}

                                    <View style={styles.lineHorizontalModal} />

                                    <View style={styles.modalButtonPanel}>
                                        <NBButton onPress={this.props.dismiss} text={"Hide"} />
                                    </View>
                                </View>
                            </ImageBackground>
                        </View>
                    </View>
                </Modal>
            </View>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        info:           state.cluesExtra,
        showCluesExtra: state.showCluesExtra
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        dismiss: () => { dispatch({type: Actions.SHOW_CLUES_EXTRA}) }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalClues);